import React, { useEffect, useState } from "react";
import { jarallax, jarallaxElement } from "jarallax";
import 'jarallax/dist/jarallax.css';
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-element.min.js';
import "jquery-ui-dist/jquery-ui";
import axiosInstance from '../axiosConfig';

const WeReOpen = () => {
    // const [settings, setSettings] = useState([]);
     const [stores, setStores] = useState([]);
     const [loading, setLoading] = useState(true);
     const [error, setError] = useState(null);


      useEffect(() => {
         const fetchstores = async () => {
           try {
             setLoading(true);
             const response = await axiosInstance.get("/store-list");
             if (response.data.success) {
               setStores(response.data.store);
             } else {
               setError(response.data.error || "Error fetching stores");
             }
           } catch (error) {
             setError("An error occurred while fetching the stores");
           } finally {
             setLoading(false);
           }
         };
     
         fetchstores();
       }, []);
 
     useEffect(() => {
         jarallax(document.querySelectorAll('.jarallax'));
     }, []);

     const LocationData = stores.map((store, index) => ({
        count: '-100',
        heading: `Branch ${index + 1}`,
        title: 'Address',
        content: store.address,
        title2: 'Phone',
        content2: store.store_phone,
    }));

    return (
        <section className="we-re-open jarallax no-top">
            <div className="de-gradient-edge-top"></div>
            <img src="assets/images/background/1.jpg" className="jarallax-img" alt="" />
            <div className="container relative z1000">
                <div className="row gx-5">
                    {LocationData.map((item, index) => (
                        <div className="col-lg-6 text-center jarallax" key={index} data-jarallax-element={item.count}>
                            <div className="d-sch-table">
                                <h2 className="wow fadeIn">{item.heading}</h2>
                                <div className="de-separator"></div>
                                <div className="d-col">
                                    <div className="d-title">{item.title}</div>
                                    <div className="d-content id-color">{item.content}</div>
                                </div>
                                <div className="d-col border-bottom-0 pb-0">
                                    <div className="d-title">{item.title2}</div>
                                    <div className="d-content id-color">{item.content2}</div>
                                </div>
                                <div className="d-deco"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="de-gradient-edge-bottom"></div>
        </section>
    );
}

export default WeReOpen;
